<template lang="pug">
    v-list(dense style="width:220px; float:right;")
        v-list-item
            v-icon(left) mdi-account-outline
            v-list-item-title {{ $t('visitor') }}
        v-divider
        v-list-item(@click="signUp()")
            v-icon(left) mdi-login
            v-list-item-title {{ $t('signup') }}
        v-list-item(@click="login()")
            v-icon(left) mdi-login
            v-list-item-title {{ $t('login') }}
        //- v-list-item(@click="plan()")
            v-icon(left) mdi-credit-card
            v-list-item-title Plans
        v-list-item(@click="aboutUs()")
            v-icon(left) mdi-information-outline
            v-list-item-title {{ $t('about_us') }}
        v-list-item(@click="goToHelp()")
            v-icon(left) mdi-help-circle-outline
            v-list-item-title {{ $t('Help') }}
            //v-icon(left) mdi-open-in-new
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'VisitorSettingsPopupWindow',
    computed: {
        user() {
            return JSON.parse(localStorage.getItem('user'))
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        signUp() {
            this.setRegisterType('signup');
            this.setRegisterWindows(true);
        },
        login() {
            this.setRegisterType('login');
            this.setRegisterWindows(true);
        },
        // plan() {
        //     const element = document.getElementById('myPremiumButtonElement');

        //     element.click();
        // },
        aboutUs() {
            this.$emit('aboutUsDialogOpen', true);
        },
        goToHelp() {
            window.open('https://intercom.help/edgerfinance/sv', '_blank');

            // const tempUser = JSON.parse(localStorage.getItem('user'));
            // const tempSettings = JSON.parse(tempUser.settings);
            // const language = tempSettings.language;

            // console.log(language);

            // if(language === "en") {
            //     //TODO: Changing to the Edger Finane when getting the address to it
            //     window.open('https://intercom.help/tradersalloy/en/', '_blank');
            // } else if(language === "se") {
            //     //TODO: Changing to the Edger Finane when getting the address to it
            //     const redirectWindow = window.open('https://intercom.help/tradersalloy/sv/','_blank');
            //     redirectWindow.location;
            // }
        }
    }
}
</script>

<style scoped>

.v-list {
    padding: 0;
}

.v-list--dense .v-list-item {
    min-height: 50px;
}

.v-list--dense .v-list-item .v-list-item__title {
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
}
.hide-element {
    visibility: hidden;
}
</style>
